<ng-container *transloco="let t; prefix: 'fuelReconciliation'">
<div class="dashboard-top-section d-flex align-items-center justify-content-between">
  <h1>{{ t('title') }}</h1>

  <div class="search-menu-lists">
    <div class="upload-button-wrap d-flex align-items-center">
      <div class="upload-button d-flex align-items-center justify-content-center spinner-btn">
        <span class="spinner-border" *ngIf="isUploading"></span>
        <span [class.disabled]="activeTab === 'reconciledSlips'">
          {{ isUploading ? t('upload.uploading') : t('upload.uploadExcelFile') }} <img src="assets/images-fuel/excelIcon.svg"
            alt="">
        </span>
        <input type="file" #fileInput accept=".xlsx,.xls,.csv" (click)="onFileInputClick($event)"
          (change)="onFileSelected($event)" [disabled]="isUploading || activeTab === 'reconciledSlips'">
      </div>
      <div class="upload-button d-flex align-items-center justify-content-center"
        [class.disabled]="activeTab === 'reconciledSlips'" (click)="openUploadPreferenceModal()">
        {{ t('upload.uploadPreference') }} <img src="assets/images-fuel/uploadIcon.svg" alt="">
      </div>
    </div>
  </div>
</div>

<div class="cmn_tabWrap">
  <div class="cmn_tabWrapUl">
    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
          type="button" role="tab" aria-controls="pills-home" aria-selected="true"
          (click)="toggleTab('fuelToReconcile')">{{ t('tabs.fuelToReconcile') }}</button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
          type="button" role="tab" aria-controls="pills-profile" aria-selected="false"
          (click)="toggleTab('reconciledSlips')">{{ t('tabs.reconciledFuelSlips') }}</button>
      </li>
    </ul>
  </div>
</div>

<div class="fuel-recon-wrapper">
  <div [hidden]="activeTab !== 'fuelToReconcile'">
    <app-fuel-recon-kpi-widgets></app-fuel-recon-kpi-widgets>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="dashboard-top-section d-flex align-items-center justify-content-between">
        <h1>{{ activeTab == 'fuelToReconcile' ? t('sections.fuelToReconcile') : t('sections.reconciledFuelSlips') }}</h1>
        <div
          class="search-menu-lists date-height d-flex align-items-center common-drop-down dropdown-button search-height gap-3">
          <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals" [disableCustomDateSelector]="false"
            [defaultInterval]="defaultInterval" (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
          <app-search [placeholder]="t('search.placeholder')" [disabled]="isLoading" [customWidth]="'320px'"
            (searchTermUpdated)="onSearchTermUpdate($event)">
          </app-search>
        </div>
      </div>
      <app-fuel-to-reconcile-table [hidden]="activeTab !== 'fuelToReconcile'" (slipReconciled)="onSlipReconciled()"></app-fuel-to-reconcile-table>
      <app-reconciled-fuel-slips-table [hidden]="activeTab !== 'reconciledSlips'" (slipDeleted)="onSlipDeleted()"></app-reconciled-fuel-slips-table>
    </div>
  </div>
</div>
</ng-container>
